import React from 'react';
import StatusChip from './StatusChip';

/**
 * Phase 4 — a thin wrapper over StatusChip so every semver renders identically
 * (vX.Y.Z). Reuses statusChipColors keys only — no new tokens.
 *   neutral → info (default), home → active (the editable minter), behind → partial,
 *   pending → warning (amber) — the predicted next version when unpublished edits exist.
 */
interface VersionChipProps {
  version: string | null | undefined;
  tooltip?: React.ReactNode;
  variant?: 'neutral' | 'home' | 'behind' | 'pending';
}

const VersionChip: React.FC<VersionChipProps> = ({ version, tooltip, variant = 'neutral' }) => {
  if (!version) return null;
  const status =
    variant === 'pending'
      ? 'warning'
      : variant === 'behind'
        ? 'partial'
        : variant === 'home'
          ? 'active'
          : 'info';
  return <StatusChip status={status} label={`v${version}`} tooltipContent={tooltip} />;
};

export default VersionChip;
